export default "__VITE_ASSET__BSr1Noi9__"